export default {"src":"/_next/static/media/pageVettingBlockBg.273dec3e.svg","height":1271,"width":1440};